export const numberToCurrencyString = (
  value: number,
  locale?: string | string[] | undefined,
  options?: Intl.NumberFormatOptions | undefined
): string => {
  locale = locale || (typeof global !== 'undefined' ? 'en-EN' : undefined)
  return value.toLocaleString(locale, options)
}
